import React, { Component, Fragment } from 'react';
import DynamicOpenModalRuleForm from './DynamicOpenModalRuleForm';
import { FieldTypes } from 'drapcode-constant';
import { builderSurfaceJsonContentHeader } from '../../../../common/utils/restApiHeaderUtils';
import axios from 'axios';
import { getSnippetModalOptions } from '../../ActionFormUtils';

export default class DynamicOpenModalRule extends Component {
  state = {
    collectionFieldValueOptions: [],
  };

  componentDidMount = () => {
    this.setCollectionValuesOptions();
  };

  shouldComponentUpdate = (nextProps, nextState, nextContext) => {
    if (this.props.selectedFieldName !== nextProps.selectedFieldName) {
      this.setCollectionValuesOptions();
    }
    return true;
  };

  setCollectionValuesOptions = async () => {
    let options = [];
    const { selectedCollectionName, selectedFieldName, collections, projectId, version } =
      this.props;
    const selectedCollection = collections.find((e) => e.collectionName === selectedCollectionName);
    const selectedCollectionFields = selectedCollection ? selectedCollection.fields : [];
    const selectedField = selectedCollectionFields.find((e) => e.fieldName === selectedFieldName);
    if (!selectedField) {
      this.setState({ collectionFieldValueOptions: options });
      return;
    }
    if (selectedField.type === FieldTypes.static_option.id) {
      selectedField.staticOptions.forEach((e) => options.push({ value: e, label: e }));
    } else if (selectedField.type === FieldTypes.dynamic_option.id) {
      const header = builderSurfaceJsonContentHeader(projectId);
      const { collectionName, collectionField } = selectedField.refCollection;
      await axios
        .get(`${process.env.REACT_APP_BUILDER_ENGINE}v${version}/items/${collectionName}/`, header)
        .then((res) => {
          if (Array.isArray(res.data)) {
            res.data.forEach((item) => {
              if (item[collectionField]) {
                options.push({
                  value: item[collectionField],
                  label: item[collectionField],
                });
              }
            });
          }
        });
    }
    this.setState({ collectionFieldValueOptions: options });
  };

  getModalOptions = () => {
    const { snippets, snippetType } = this.props;
    let modalOptions = [];
    if (snippetType === 'SUB_PAGE') {
      const subPageSnippet = snippets.filter((snippet) => snippet.snippetType === 'SUB_PAGE');
      subPageSnippet.forEach((snippet) => {
        modalOptions.push({
          value: snippet.uuid,
          label: snippet.name,
        });
      });
    } else modalOptions = getSnippetModalOptions(snippets);
    return modalOptions;
  };

  render() {
    const {
      createNewParamRow,
      params,
      selectedCollection,
      selectedCollectionField,
      collections,
      collectionFrom,
      snippetType,
    } = this.props;
    return (
      <Fragment>
        <div className="table-responsive">
          <table className="table table-sm table-bordered table-condensed">
            <thead style={{ fontWeight: 'bold' }}>
              <tr>
                <td className="text-left w-50">Field Value</td>
                <td className="text-left"> {snippetType === 'SUB_PAGE' ? 'Subpage' : 'Modal'} </td>
              </tr>
            </thead>
            <tbody>
              {params.map((row) => {
                return (
                  <DynamicOpenModalRuleForm
                    paramRow={row}
                    key={row.id}
                    createNewRow={createNewParamRow}
                    selectedCollection={selectedCollection}
                    selectedCollectionField={selectedCollectionField}
                    collections={collections}
                    collectionFieldValueOptions={this.state.collectionFieldValueOptions}
                    modalOptions={this.getModalOptions()}
                    collectionFrom={collectionFrom}
                  />
                );
              })}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
}
